let shouldClear = false

/**
 * Clear messages when switching pages
 *
 * @param {object} context
 * @param {object} context.store
 */
export default function ({ store }) {
    // Clear non-flash messages
    store.dispatch('messages/clearNormalMessages')

    // Set flag to clear messages on next page load
    if (store.getters['messages/hasFlashMessages'] && !shouldClear) {
        shouldClear = true

        return
    }

    // Clear all messages
    if (shouldClear) {
        store.dispatch('messages/clearMessages')
        shouldClear = false
    }
}
